# Used by all products.
# It handles the whole chat display in the messaging section

# selectors
chat = '[data-behaviour="chat"]'
scrollPos = 0
numItems = 0 # cache of the number of items in the chat

# prevent elements from outside the chat, from taking over the scroll, when scrolling the chat into the edges
preventOverScrolling = (el) ->
  scrollPos = el.scrollTop
  maxScrollPos = el.scrollHeight - el.clientHeight
  if scrollPos <= 0 # detect top
    scrollPos = 1
  else if scrollPos >= maxScrollPos # detect bottom
    scrollPos = maxScrollPos - 1
  el.scrollTop = scrollPos

setupScroll = ->
  $(chat).on 'scroll', ->
    preventOverScrolling @

setupInput = ->
  $input = $ $(chat).data 'view'
  $t = $input.find 'textarea'
  $submit = $input.find('[type="submit"]')
  $submit.on 'click', (ev) ->
    ev.preventDefault()
    @disabled = true
    $(@form).addClass('submitted')[0].submit()
  resize = (el) ->
    offset = el.offsetHeight - el.clientHeight
    $(el).css('height', 'auto').css 'height', el.scrollHeight + offset
  # NOTE: setupInput is called without a receiver, so `this` is undefined here
  # (ES modules are always strict). Under webpack this was the non-strict
  # `window`, where resizing was a no-op, so skip it rather than raise -- which
  # would abort before the keyup handler below is bound.
  resize @ if @?
  $t.on 'keyup', ->
    $submit[0].disabled = !@value.trim().length || $(@).closest('form').hasClass('submitted')
  $t.on 'resize', resize
  $t.on 'input', ->
    resize @
    $(chat).trigger 'update'
  $t.on 'keydown', ->
    $el = $ @
    curInputHeight = $input.outerHeight true
    inputHeight = parseInt $el.attr('data-height') || 0
    if inputHeight != curInputHeight
      $el.attr 'data-height', curInputHeight
      resize @
      $(chat).trigger 'update'

setupChat = ->
  if($chat = $ chat).length
    $input = $ $chat.data('view') # chat input wrapper
    inputHeight = $input.outerHeight true

    $chat.on 'update', ->
      curInputHeight = $input.outerHeight true
      $chat.height $(window).height() - $chat.offset().top - curInputHeight

      # check if the size of the input wrapper has changed, either bigger or smaller
      if inputHeight != curInputHeight
        scrollPos = scrollPos + curInputHeight - inputHeight
        inputHeight = curInputHeight

      # if we have more chat items, move the scroll position to the bottom
      curNumItems = $chat.children().length
      if curNumItems > numItems
        scrollPos = $chat[0].scrollHeight
        numItems = curNumItems

      $chat.scrollTop scrollPos
      setupScroll()

    $chat.trigger 'update'

reload = ->
  setupChat()

load = ->
  if($chat = $ chat).length
    scrollPos = $(chat)[0].scrollHeight
    setupChat()
    setupInput()

$(document).ready(load)
$(document).on 'reload:done', load
$(window).resize load
